import { combineReducers } from "@reduxjs/toolkit";
import productsReducer from "./products/products.slice";
import listingsReducer from "./listings/listings.slice";
import protocolReducer from "./protocol/protocol.slice";
import unitsReducer from "../units";
import userReducer from "./user/user.slice";


const rootReducer = combineReducers({
  products: productsReducer,
  listings: listingsReducer,
  protocol: protocolReducer,
  user: userReducer });

export default rootReducer;
